import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { withStyles } from '@material-ui/core/styles'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import ActionDelete from '@material-ui/icons/Delete'
import Button from '@material-ui/core/Button'
import ContentAdd from '@material-ui/icons/Add'
import ContentRemove from '@material-ui/icons/Remove'
import DeleteForever from '@material-ui/icons/DeleteForever'
import GiftCard from '@material-ui/icons/CardGiftcard'
import Paper from '@material-ui/core/Paper'
import IconButton from '@material-ui/core/IconButton'
import ActionInfo from '@material-ui/icons/Info'
import Tooltip from '@material-ui/core/Tooltip'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

const styles = theme => ({
  container: {
    height: '60px',
    display: 'flex',
    flexWrap: 'nowrap',
    overflow: 'auto'
  },
  labelTitle: {
    lineHeight: '60px',
    flex: 1,
    marginLeft: 10,
    order: 1
  },
  labelReduc: {
    color: theme.palette.secondary.main,
    lineHeight: '60px',
    marginRight: 10,
    order: 1
  },
  buttonLeft: {
    margin: 10,
    verticalAlign: 'center',
    marginLeft: 'auto',
    order: 2
  },
  labelCounter: {
    lineHeight: '60px',
    order: 3
  },
  buttonRight: {
    margin: 10,
    verticalAlign: 'center',
    order: 4
  },
  reduc: {
    marginRight: 5,
    marginLeft: 'auto',
    verticalAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    order: 2
  },
  center: {
    display: 'flex',
    alignItems: 'center'
  },
  infoIcon: {
    width: 30,
    height: 30,
    order: 1
  }
})
class ConsoItemComponent extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    grouped: PropTypes.bool.isRequired,
    showTime: PropTypes.bool.isRequired,
    product: PropTypes.object.isRequired,
    transaction: PropTypes.object,
    addConso: PropTypes.func.isRequired,
    removeConso: PropTypes.func.isRequired,
    changeReduc: PropTypes.func
  }
  handleAddConso = e => {
    this.setState({ disabled: true })
    this.props.addConso(this.props.product)
  }
  handleRemoveConso = e => {
    if (this.props.transaction && !this.props.product.id_sale_product_detail) {
      return
    }
    this.setState({ disabled: true })
    this.props.removeConso(this.props.product)
  }
  handleChangeReduc = event => {
    const value = event.target.value
    if (value) {
      this.props.changeReduc(this.props.transaction, this.props.product, value)
    } else if (value === 0) {
      this.props.changeReduc(this.props.transaction, this.props.product, value)
    } else {
      this.props.changeReduc(this.props.transaction, this.props.product, 100)
    }
  }
  render() {
    return this.props.grouped ? this.renderGrouped() : this.renderUnGrouped()
  }
  renderGiftButton() {
    const { classes, product } = this.props
    const reduc = product.reduc
    if (!reduc) {
      return (
        <Button
          onClick={this.handleChangeReduc}
          variant="fab"
          color="primary"
          mini
          className={classes.buttonLeft}>
          <GiftCard color="inherit" />
        </Button>
      )
    }
    return (
      <div className={classes.reduc}>
        <FormControl>
          <Select
            value={product.reduc}
            onChange={this.handleChangeReduc}
            inputProps={{
              name: 'reduc',
              id: 'reduc-simple'
            }}>
            <MenuItem value={0}>0%</MenuItem>
            <MenuItem value={10}>10%</MenuItem>
            <MenuItem value={20}>20%</MenuItem>
            <MenuItem value={30}>30%</MenuItem>
            <MenuItem value={40}>40%</MenuItem>
            <MenuItem value={50}>50%</MenuItem>
            <MenuItem value={60}>60%</MenuItem>
            <MenuItem value={70}>70%</MenuItem>
            <MenuItem value={80}>80%</MenuItem>
            <MenuItem value={90}>90%</MenuItem>
            <MenuItem value={100}>100%</MenuItem>
          </Select>
        </FormControl>
      </div>
    )
  }
  renderUnGrouped() {
    const { classes, product, transaction } = this.props
    const price = product.price
    const priceLabel = price === '0.00' ? 'Offert' : price + ' €'
    let label = product.name + ' - ' + priceLabel
    if (this.props.showTime) {
      label += ' (' + moment(product.added).format('HH:mm:ss') + ')'
    }
    const disabled = transaction && !product.id_sale_product_detail
    return (
      <Grid item xs={11}>
        <Paper className={classes.container} elevation={2}>
          <Tooltip
            className={classes.center}
            id="tooltip-right"
            title={moment(product.createdAt).format('DD/MM/YY - HH:mm:ss')}
            placement="right">
            <IconButton className={classes.infoIcon}>
              <ActionInfo color="primary" />
            </IconButton>
          </Tooltip>
          <Typography variant="body2" className={classes.labelTitle} noWrap>
            {label}
          </Typography>
          {this.renderGiftButton()}
          <Button
            disabled={disabled}
            onClick={this.handleRemoveConso}
            mini
            variant="fab"
            className={classes.buttonRight}
            color="secondary">
            <DeleteForever color="inherit" />
          </Button>
        </Paper>
      </Grid>
    )
  }
  renderGrouped() {
    const { classes, product, transaction } = this.props
    const reduc = product.reduc === void 0 ? 0 : product.reduc
    const price = Number(product.price).toFixed(2)
    const priceLabel = price === '0.00' ? 'Offert' : price + ' €'
    let reducLabel
    if (reduc && reduc > 0) reducLabel = '(-' + reduc + ' %)'
    const label = product.name + ' - ' + priceLabel
    const disabled = transaction && !product.id_sale_product_detail
    return (
      <Grid item xs={11}>
        <Paper className={classes.container} elevation={2}>
          <Typography variant="body2" noWrap className={classes.labelTitle}>
            {label}
          </Typography>
          {reducLabel !== '' ? (
            <Typography variant="caption" className={classes.labelReduc}>
              {reducLabel}
            </Typography>
          ) : null}
          {product.counter > 1 ? (
            <Button
              onClick={this.handleRemoveConso}
              disabled={disabled}
              mini
              variant="fab"
              color="primary"
              className={classes.buttonLeft}>
              <ContentRemove color="inherit" />
            </Button>
          ) : (
            <Button
              onClick={this.handleRemoveConso}
              disabled={disabled}
              mini
              variant="fab"
              className={classes.buttonLeft}
              color="secondary">
              <ActionDelete color="inherit" />
            </Button>
          )}
          <span className={classes.labelCounter}>{product.counter}</span>
          <Button
            onClick={this.handleAddConso}
            mini
            variant="fab"
            color="primary"
            className={classes.buttonRight}>
            <ContentAdd color="inherit" />
          </Button>
        </Paper>
      </Grid>
    )
  }
}

export default withStyles(styles)(ConsoItemComponent)



// WEBPACK FOOTER //
// ./src/components/SideBarConsosComponent/ConsoItemComponent.js